module.exports = __webpack_public_path__ + "static/media/profile.3a74caae.png";